import { render } from "./AdminUsuarios.vue?vue&type=template&id=167c29cc"
import script from "./AdminUsuarios.vue?vue&type=script&lang=js"
export * from "./AdminUsuarios.vue?vue&type=script&lang=js"

import "./AdminUsuarios.vue?vue&type=style&index=0&id=167c29cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__